import { customAlphabet } from 'nanoid'

const shortid = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$@', 14)

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.mixin({
      methods: {
        $shortid () {
          return shortid()
        },
      },
    })
  },
}
